window.Reverb = window.Reverb || {};

Reverb.OpenLightboxOnLoad = (function () {
  const openLightbox = '[data-open-lightbox-onload]';

  function openLightboxOnLoad() {
    const $lightbox = $(openLightbox);

    if ($lightbox.length > 0) {
      $.fancybox($lightbox);
    }
  }

  return {
    openLightboxOnLoad,
  };
}());

$(() => {
  Reverb.OpenLightboxOnLoad.openLightboxOnLoad();
});



// WEBPACK FOOTER //
// ./src/components/legacy/open_lightbox_on_load.js